var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppLayout from '@/Layouts/AppLayout';
import Tabs from '@/Jetstream/Tabs';
import { BuildingOfficeIcon, Cog8ToothIcon, CreditCardIcon, UsersIcon } from "@heroicons/react/24/outline";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
export default function TeamSettingsLayout(_a) {
    var team = _a.team, title = _a.title, pageTitle = _a.pageTitle, children = _a.children;
    var route = useRoute(Ziggy);
    var current = window.location.href.replace(/\?.*/, '');
    console.log('TeamSettingsLayout...', current);
    return (_jsxs(AppLayout, __assign({ title: title, pageTitle: pageTitle }, { children: [_jsx(Tabs, { tabs: [
                    {
                        id: 'settings-tab',
                        "name": 'Team settings',
                        "href": route('teams.show', { "team": team.id }),
                        "icon": Cog8ToothIcon,
                        "current": current.match(/teams\/\d+$/),
                        count: null,
                    },
                    {
                        id: 'members-tab',
                        "name": 'Team members',
                        "href": route('team.users', { "team": team.id }),
                        "icon": UsersIcon,
                        "current": current.match(/user/),
                        count: null,
                    },
                    {
                        id: 'branches-tab',
                        "name": 'Branches',
                        "href": route('team.branches', { "team": team.id }),
                        "icon": BuildingOfficeIcon,
                        "current": current.match(/teams\/\d+\/branches$/),
                        count: null,
                    },
                    {
                        id: 'billing-tab',
                        "name": 'Billing',
                        "href": team.permissions.isAdmin ? route('billing-portal.subscription.index', { "team": team.id }) : '#',
                        "icon": CreditCardIcon,
                        "current": current.match(/billing/),
                        count: null,
                        disabled: !team.permissions.isAdmin
                    },
                ].filter(Boolean) }), children] })));
}
